export const enum GiverHomePageRouteType {
  Explore = 0,
  TakeInterview = 1,
  History = 2,
  Upcoming = 3,
}
